import RequestManager from "./RequestManager";

const getStatus = async () => {
    const response = await RequestManager.get({
        url: "/status/v1"
    });
    return response;
};

const Status = {
    getStatus
};

export default Status;